export default "__VITE_ASSET__abe5614c__"